.header-back-button{margin-left:-8px}.header-container{width:100%}.header-subtitle{margin-top:13px}.header-subtitle-divider{margin-left:5px;margin-right:5px}.header-title{margin-bottom:0;margin-top:21px}
/*# sourceMappingURL=header-bar.component-DVVVW3IN.css.map */
